import axios from "axios";

const API_URL = "/api/v1"

// Синхронная проверка: пользователь считается авторизованным,
// если в localStorage есть токен и user_id (записываются при входе/регистрации)
export const checkAuth = () => {
    return localStorage.getItem('token') !== null &&
        localStorage.getItem('user_id') !== null
}

export const getLogin = () => localStorage.getItem('login')

// Асинхронная проверка токена на сервере
export const validateAuth = async () => {
    const token = localStorage.getItem('token')

    if (token === null) {
        return false
    }

    try {
        const response = await axios.get(API_URL + "/users/me?token=" + encodeURIComponent(token))
        return response.status === 200
    } catch (e) {
        return false
    }
}

// Сохранение сессии после входа/регистрации
export const saveSession = (data) => {
    localStorage.setItem('token', data.token)
    localStorage.setItem('user_id', data.user_id)
    localStorage.setItem('login', data.login)
}

// Выход: отзыв токена на сервере и очистка localStorage
export const logout = () => {
    const token = localStorage.getItem('token')

    const clear = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user_id')
        localStorage.removeItem('login')
    }

    if (token === null) {
        clear()
        return Promise.resolve()
    }

    return axios.post(API_URL + "/auth/logout?token=" + encodeURIComponent(token))
        .catch(() => {})
        .then(clear)
}
